import {
  GET_OV_FILTER_SUGGESTIONS,
  CLEAR_OV_FILTER_SUGGESTIONS,
  SET_OV_FILTER_INPUT_VALUE,
  SET_OV_FILTER_ALL,
  SET_EXCLUDE_ZERO_COMPUTE,
  SET_MIN_STORAGE_COST_ENABLED,
  SET_MIN_STORAGE_COST,
} from "../actions/overviewParams";

import moment from "moment";
/* 
There is a reason why we handle all 
the filters in one reducer - contents of 
filter autosuggest boxes depend on 
each other.

However, it might not be necessary as we may
be able to do it all in the thunks.
*/

export const generateDefaultPeriod = () => {
  return {
    start: moment
      .utc()
      .subtract(1, "week")
      .startOf("day"),
    end: moment.utc().startOf("day")
  };
};

export const initialFiltersState = {
  account: { suggestions: [], inputValue: "", selected: {}, enabled: true },
  user: { suggestions: [], inputValue: "", selected: {}, enabled: false },
  metakey: { suggestions: [], inputValue: "", selected: {}, enabled: false },
  metavalue: { suggestions: [], inputValue: "", selected: {}, enabled: false },
  period: generateDefaultPeriod(),
  granularity: "AUTO_100",
  excludeZeroCompute: true,
  minStorageCostEnabled: false,
  minStorageCost: 1,
};

const mergeFilterVal = (state, filterKey, obj) => {
  return Object.assign({}, state, {
    [filterKey]: Object.assign({}, state[filterKey], obj)
  });
};

function overviewFilters(state = initialFiltersState, action) {
  switch (action.type) {
    case GET_OV_FILTER_SUGGESTIONS:
      return mergeFilterVal(state, action.filterKey, {
        suggestions: action.suggestions
      });

    case CLEAR_OV_FILTER_SUGGESTIONS:
      return mergeFilterVal(state, action.filterKey, { suggestions: [] });

    case SET_EXCLUDE_ZERO_COMPUTE:
      return {
        ...state,
        excludeZeroCompute: action.payload,
      };

    case SET_MIN_STORAGE_COST_ENABLED:
      return {
        ...state,
        minStorageCostEnabled: action.payload,
      };

    case SET_MIN_STORAGE_COST:
      return {
        ...state,
        minStorageCost: action.payload,
      };

    /*
    Two or more suggestions may have the same name, therefore we can't rely
    on the user just typing a name. Even if the names are
    unique we still need to let the user know whether the input relates to
    a real thing. So they must eventually select
    from the suggestions, at which point the value is valid and we record
    the suggestion object in the selected property. As such, we wipe the
    selected object as soon as the user changes the input leaving it out
    of sync with the selected object.

    Future enhgancement: we can check if the typed value is unique within
    the possibillities and if so consider it valid and selected.

    Update: this enhancement has now been made for autosuggest and is 
    handled in the autosuggest component itself. First paragraph^ still stands.
    */

    case SET_OV_FILTER_INPUT_VALUE:
      const nextObj = { inputValue: action.value };
      if (action.value !== state[action.filterKey].selected.text) {
        nextObj.selected = {};
      }
      return mergeFilterVal(state, action.filterKey, nextObj);

    case SET_OV_FILTER_ALL:
      const account = Object.assign({}, state.account, {
        selected: action.account,
        inputValue: action.account.text
      });


      const period = generateDefaultPeriod();
      if (action.start) {
        period.start = moment.utc(action.start).startOf("day");
      }
      if (action.end) {
        period.end = moment.utc(action.end).startOf("day");
      }

      return Object.assign({}, state, {
        account,
        granularity: action.granularity || initialFiltersState.granularity,
        period
      });

    default:
      return state;
  }
}

export default overviewFilters;



// WEBPACK FOOTER //
// ./src/reducers/overviewFilters.js